import { Link, Stack } from '@mui/material';
import { nanoid } from 'nanoid';
import Image from 'next/image';

/**
 * @name SocialNav
 * @description Displays social navgiation links of footer
 * @param {*} param0 - Destructured object
 * @param {object} param0.data - Footer navigation data from strapi
 * @returns {JSX.Element} ReactElement
 */
const SocialNav = ({ data }) => (
    <Stack direction='row' justifyContent='center' spacing={{ xs: 2, sm: 4 }}>
      {data?.SocialNav?.map(link =>
        link?.Link?.map(nav => (
          <Link key={nanoid(8)} href={nav?.link} component='a' aria-label={nav?.ariaLabel}>
            {link?.image && (
              <Image
                height={24}
                width={24}
                alt={link?.image?.data?.attributes?.alternativeText}
                src={`${link?.image?.data?.attributes?.url}`}
              />
            )}
          </Link>
        )))}
    </Stack>
);

SocialNav.displayName = 'SocialNav';
export default SocialNav;
